var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('app-bread-crumbs',{attrs:{"routes":[
      { name: 'home', title: 'Accueil' },
      { name: 'reportNew', title: 'Rapport' },
      { name: 'card', title: 'Étape climat' },
    ]}}),_c('b-row',{staticClass:"mt-2 mb-2"},[_c('b-col',{staticClass:"mb-3"},[_c('b-img',{attrs:{"src":"/img/logo_abc_full.svg","height":"100px","alt":"Logo Parcours ABC"}})],1)],1),_c('app-card-direct')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }